export const prebidId5 = {
    id: 'PrebidId5',
    author: '@commercial-dev',
    start: '2025-05-07',
    expiry: '2025-05-30',
    audience: 2 / 100,
    audienceOffset: 0 / 100,
    audienceCriteria: '',
    successMeasure: '',
    description: 'Test enabling the ID5 module in prebid.js',
    variants: [
        {
            id: 'control',
            test: () => {
                /* no-op */
            },
        },
        {
            id: 'variant',
            test: () => {
                /* no-op */
            },
        },
    ],
    canRun: () => true,
};
